import { useState } from 'react';

function detectAndroid(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /android/.test(navigator.userAgent.toLowerCase());
}

/** Synchronous on first paint — avoids flashing desktop-only buttons on Android. */
export const useAndroidDetection = (): boolean => {
  const [isAndroid] = useState(detectAndroid);
  return isAndroid;
};

export const useMobileDetection = (): boolean => {
  const [isMobile] = useState(() => {
    if (typeof navigator === 'undefined') return false;
    return /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
      navigator.userAgent.toLowerCase(),
    );
  });
  return isMobile;
};
